import React, { useState } from "react";
import {
    Modal, Input, message
} from "antd";
import ReportsServices from "../../services/Reports.services";
import { fGetDashboardJSON } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { downloadJSON } from "../../utils/MainHelper";

function SaveAnalysisModal({
    visible,
    onClose = () => {}
}) {
    const [filename, setfilename] = useState(ReportsServices.getMastersTargetAudience());

    return (
        <Modal
            className="report--freeformmodal"
            open={visible}
            closable={false}
            maskClosable={false}
            title="Save Dashboard"
            okText="Proceed"
            onCancel={() => {
                onClose(false);
            }}
            onOk={async () => {
                if (!filename) {
                    message.warning("Please input filename.");
                    return;
                }
                const sessionJson = await fGetDashboardJSON(filename);
                downloadJSON(filename, sessionJson);
                onClose(false);
            }}
        >
            <div className="d-flex-col justify-content-center gap-1">
                <span>Filename: </span>
                <Input
                    value={filename}
                    onChange={(e) => setfilename(e.target.value)}
                />
            </div>

        </Modal>
    );
}

export default SaveAnalysisModal;
